﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getCustomer, getCustomers, saveCustomer, deleteCustomer, syncCustomerOrders, statusCustomer } from "@/api/Maintainers/customers";

const key = "customers";

export function useCustomer(selected) {
	return useQuery([key, selected], () => selected && getCustomer({ selected }));
}

export function useCustomersPaginate(params) {
	return useQuery([key, params], () => getCustomers(params));
}

export function useMutateCustomer(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveCustomer, {
		onSuccess: (response) => {
			const customers = _.omit(response, "detail");
			const customer = _.omit(response, key);

			queryClient.setQueryData([key, String(customer.detail.id)], customer);
			queryClient.setQueryData([key, params], customers);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/clientes");
		},
	});
}

export function useMutateDeleteCustomer(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteCustomer, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}

export function useMutateStatusCustomer(params) {
	const queryClient = useQueryClient();

	return useMutation(statusCustomer, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}

export function useMutateSyncCustomerOrders() {
	return useMutation(syncCustomerOrders, {});
}
